import { toast } from 'react-toastify';

/** Single id so async actions (AI, refresh, imports) do not stack loading toasts */
export const APP_LOADING_TOAST_ID = 'app-async-loading';

export function showAppLoadingToast(message = 'Loading…') {
  return toast.loading(message, {
    toastId: APP_LOADING_TOAST_ID,
    position: 'top-right',
    closeButton: false,
    draggable: false,
  });
}

export function dismissAppLoadingToast() {
  toast.dismiss(APP_LOADING_TOAST_ID);
}

export function appLoadingDone(successMessage) {
  dismissAppLoadingToast();
  if (successMessage) {
    toast.success(successMessage, { autoClose: 2200 });
  }
}

export function appLoadingFailed(message) {
  dismissAppLoadingToast();
  if (message) {
    toast.error(message, { autoClose: 5000 });
  }
}
